import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import axios from '../config'
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import Cookies from 'js-cookie';


import { Button, Divider, } from '@mui/material';


import { Sources, iconColors } from '../helpers/scripts'
import { creatShipementInServer } from "../helpers/requests";


import ModuleOrder from '../components/ModuleOrder';
import ModuleNotification from '../components/ModuleNotification';
import ModuleShipment from '../components/ModuleShipment';

import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';


const OrderDetail = () => {

    const params = useParams()
    const id = params.id
    const location = useLocation();
    const navigate = useNavigate()

    const [order, setOrder] = useState({})
    const [open, setOpen] = useState(false);

    // console.log('OrderDetail', location.state.page)


    const updateOrder = (e) => {

        let value = e.target.value
        let key = e.target.name

        if (key.includes('.')) {
            let [mainKay, Key] = key.split('.')
            if (mainKay === 'source') {
                setOrder({ ...order, ['source']:Sources[value] })
            } else {
                setOrder({ ...order, [mainKay]:{ ...order[mainKay], [Key]:value } })
            }
        } else {
            if (key === 'totalQuantity') {
                value = +value
            } else if (key === 'totalOrderPrice') {
                parseFloat(value).toFixed(2)
            }    
            setOrder({...order, [key]:value})
        } 
    }


    
    const getOrder = async () => {
        const rs = await axios.get(`/uorders/${id}`, {headers:{'token': Cookies.get('token')}})

        if (rs.data.id){
            let NEW_ORDER = rs.data

            if ( NEW_ORDER.shipments.length > 0 ) {

                let NEW_NORIFS = []

                for ( let shipment in NEW_ORDER.shipments ){
                    const ID = NEW_ORDER.shipments[shipment].id
                    const rs_notif = await getNotification(ID)
                    if ('id' in rs_notif){
                         NEW_NORIFS.push(rs_notif)
                    }
                   
                }

                setOrder({...NEW_ORDER, ['notifications']:[...NEW_ORDER.notifications, ...NEW_NORIFS]})
               
            } else {

                setOrder(NEW_ORDER)
                
            }
        }


    }


    const updateOrderInServer = async (close) => {

        const ORDER = {
            // '_id': order.id,
            'id': order.id,
            'date': dayjs(order.date).format(),
            'orderID': order.orderID,
            'messageID': order.messageID,
            'isCancel': order.isCancel,
            'totalQuantity': order.totalQuantity,
            'totalProductPrice': order.totalProductPrice,
            'deliveryPrice': order.deliveryPrice,
            'totalOrderPrice': order.totalOrderPrice,
            'paymentType': order.paymentType,
            'source': order.source,
            'user': {
                'nikename': order.user.nikename,
                'firstName': order.user.firstName,
                'lastName': order.user.lastName,
                'email': order.user.email,
                'phone': order.user.phone
            },
            'address': {
                'street': order.address.street,
                'street_1':order.address.street_1,
                'index':  order.address.index,
                'city':   order.address.city,
                'state':  order.address.state,
                'country':  order.address.country,
                'countryCode':  order.address.countryCode
            }
        }
        
        try {
            const rs = await axios.post(`/uorders/${order.id}`, JSON.stringify(ORDER), { headers: { 'Content-Type': 'application/json', 'token': Cookies.get('token')} })
            console.log(rs.headers)
            console.log(rs.data)
            
            if (rs.data.modified_count){
                setOpen(true);

            }
            if (close === true) {
                navigate(`/orders/`,  { state: { 'page': location?.state?.page ? location.state.page : 0, 'from':  'OrderDetail'} }) 
            }


        } catch (error) {
            console.log(error)
            
        }
    
       

    }

    const deleteOrder = async ()=>{
        const l = 135
        let ms = prompt(`Введите цифру ${l}`);
        
        if (l === +ms) {
            const rs = await axios.delete(`/uorders/${id}`, {headers:{'token': Cookies.get('token')}})
            if (rs.data){
                console.log(rs.data)
                navigate(`/orders/`,  { state: { 'page': location?.state?.page ? location.state.page : 0, 'from':  'OrderDetail'} })
            }

           
        }

    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
    }

    const creatShipement = async ()=>{
        const shipment = await creatShipementInServer(order.id)
        navigate(`/shipments/${shipment.id}`)
    }

    useMemo(()=>{
            getOrder()
    },[])



    const getNotification = async (id) => {
        const rs = await axios.get(`/unotifications/${id}`, {headers:{'token': Cookies.get('token')}})

        let NEW_NOTIF = {}

        try {
            if (rs.data.item_id) {
                NEW_NOTIF = rs.data
            }
        } catch (error) {
            console.log(error)
        }

        return NEW_NOTIF

    }

   

    return (
        <>

        <Divider sx={{my:2}} />
        {/* SUB MENU */}
        <div style={{display:'flex'}}>

            <div style={{ width:'300px'}}>
                <Button 
                    size='small'
                    variant='outlined' 
                    onClick={ ()=>{  navigate(`/orders/`,  { state: { 'page':  location?.state?.page ? location.state.page : 0, 'from':  'OrderDetail'} })  }}
                    >Вернуться к списку заказов
                </Button>

            </div>

            <div style={{marginRight:0, marginLeft:'auto'}}>
                 
                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:4}}
                    onClick={()=>deleteOrder()}
                    >Удалить заказ
                </Button>

                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:4}}
                    onClick={()=>creatShipement()}
                    >Создать отправку
                </Button>

                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:4}}
                    onClick={()=>updateOrderInServer(false)}
                    >Записать
                </Button>

                <Button 
                    variant='outlined' 
                    size='small'
                    sx={{marginRight:3}}
                    onClick={()=>updateOrderInServer(true)}
                    >Записать и закрыть
                </Button>              

            </div>
            <CloseIcon 
                sx={{color:iconColors.blue, cursor:'pointer' }}
                onClick={  ()=>{  navigate(`/orders/`,  { state: { 'page':  location?.state?.page ? location.state.page : 0, 'from':  'OrderDetail'} }) }} />
        </div>

            
        
        { order.id ?  <ModuleOrder order={order} updateOrder={updateOrder} getNotification={getNotification} setOrder={setOrder} /> : '' }

            {
                order.notifications ? 
                    order.notifications.filter( i => i.item_id === order.id).map((notif)=>
                        <ModuleNotification key={notif.id} data={notif} />
                    ) : ''
        
            }

            

            {
                order.shipments ?
                    order.shipments.map( shipment => 
                        <div key={shipment.id}>
                            <ModuleShipment shipment={shipment} />
                            {
                                order.notifications ? 
                                    order.notifications.filter( i => i.item_id === shipment.id).map((notif)=>
                                        <ModuleNotification key={notif.id} data={notif} />
                                    ) : ''
                        
                            }
                        </div>) :''
            }

            <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    message='Заказ обновлен'
                />

            </>
    );
}

export default OrderDetail;
